import { RecurringSeriesRequest } from '@spike/new-booking-model';
import { previewRecurringSeriesThunk, resetRecurringSeriesThunk } from '@spike/new-bookings-action';
import { useApiClientWrapper } from 'hooks';
import { useDebounce } from 'hooks/useDebounce';
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';

const PREVIEW_DEBOUNCE_MS = 400;

const getPreviewKey = (request: RecurringSeriesRequest): string =>
    JSON.stringify({
        appointments: request.appointments.map(appointment => ({ ...appointment, notes: undefined })),
        items: request.order?.items,
        recurrence: request.recurrence
    });

export const useRecurringSeriesPreview = (request: RecurringSeriesRequest | undefined): void => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();
    const requestRef = useRef(request);
    requestRef.current = request;

    const key = useMemo(() => (request ? getPreviewKey(request) : undefined), [request]);
    const debouncedKey = useDebounce(key, PREVIEW_DEBOUNCE_MS);

    useEffect(() => {
        if (debouncedKey !== undefined && requestRef.current) {
            dispatch(previewRecurringSeriesThunk(apiClientWrapper, requestRef.current));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedKey]);

    useEffect(
        () => () => {
            dispatch(resetRecurringSeriesThunk());
        },
        [dispatch]
    );
};

export default useRecurringSeriesPreview;
